module.exports = __webpack_public_path__ + "static/media/uk.b8a75c53.svg";